import { SvgIcon, SvgIconProps } from '@mui/material';

export const XingIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 384 512">
    <path d="M163 210c-2 3-26 44-70 124-5 8-11 12-18 12H10c-8 0-12-7-9-14l69-122-44-76c-4-7 1-14 9-14h65c7 0 13 4 18 13l45 77zM383 46 239 299l91 167c4 7 0 14-8 14h-66c-7 0-13-4-17-12l-93-169L291 44c4-8 10-12 17-12h66c8 0 12 7 9 14z" />
  </SvgIcon>
);
